define(
    'viewmodels/secured/uploads/context',[
        "durandal/app",
        "viewmodels/ViewModel",
        "providers/dataprovider"
    ],
    function (app, ViewModel, dataProvider) {
        var vm = new ViewModel();

        var _promise1 = null;

        vm.loadForUploadRequests = function (lastdays, isMy) {
            var d = $.Deferred();

            dataProvider.folders
            .getSharedUploadRequests(lastdays, isMy)
            .done(function (result) {
                var data = _.map(result, function (itm) {

                    itm.expiry = moment(itm.expiry).isValid() ? kendo.toString(kendo.parseDate(itm.expiry), "g") : itm.expiry;

                    return itm;
                });

                d.resolve(data);
            })
            .fail(function (e) {
                d.reject(e);

                console.error(e);
            });

            return d.promise();
        };
        vm.loadForUploadRequestDetails = function (id) {
            var d = $.Deferred();

            if (_promise1 == null) {
                _promise1 = d;

                dataProvider.folders
                .getSharedUploadRequestDetails(id)
                .done(function (data) {                    
                    d.resolve(data);
                    if (_promise1) {
                        _promise1.resolve(data);
                    }
                })
                .fail(function (e) {
                    d.reject(e);
                    _promise1.reject(e);

                    console.error(e);
                })
                .always(function () {
                    _promise1 = null;
                });

            } else {
                _promise1.done(function (data) {
                    d.resolve(data);
                });
            }

            return d.promise();
        };
        vm.cancelForUploadRequest = function (id) {
            var d = $.Deferred();

            dataProvider.folders
            .cancelSharedUploadRequest(id)
            .done(function () {
                d.resolve();
            })
            .fail(function (e) {
                d.reject(e);

                console.error(e);
            });

            return d.promise();
        };

        return vm;
    });
